module.exports = __webpack_public_path__ + "static/media/delivery-icon.be077782.svg";